import React, { useState, useEffect } from "react";
import Loader from "./Loader";

const DelayedLoader = ({ delay = 500 }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), delay);
    return () => clearTimeout(t);
  }, [delay]);

  return show ? <Loader /> : null;
};

export default DelayedLoader;
